export default __webpack_public_path__ + "static/media/Flex_Med.ad7f79a9.png";